import WorkIm from "../assets/projects/getir.png";
import RealEst from "../assets/projects/spotify.png";
import Web from "../assets/projects/web.png";
import Rick from "../assets/projects/rick.png";
import Adds from "../assets/projects/adds.png";

export const data = [
  {
    id: 1,
    name: "React and TailwindCss clone application",
    image: WorkIm,
    github: "https://github.com/Mertcan-polat/Clone-Getir-Website",
    live: "https://github.com/Mertcan-polat/Clone-Getir-Website",
  },
  {
    id: 2,
    name: "Spotify Clone application with redux and router-dom",
    image: RealEst,
    github: "https://github.com/Mertcan-polat/Spotify-Clone",
    live: "https://github.com/Mertcan-polat/Spotify-Clone",
  },
  {
    id: 3,
    name: "E-commerce Web App",
    image: Web,
    github: "https://github.com/Mertcan-polat/APL-MAG",
    live: "https://frolicking-macaron-59de2c.netlify.app/",
  },
  {
    id: 4,
    name: "NextJs-GraphQl Rick and Morty",
    image: Rick,
    github: "https://github.com/Mertcan-polat/Next-GraphQl",
    live: "https://frolicking-macaron-59de2c.netlify.app/",
  },
  {
    id: 5,
    name: "My Upwork job",
    image: Adds,
    github: "https://github.com/Mertcan-polat/www.adds.com",
    live: "https://www.adss.com.tr/",
  },
];
